import React, { useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getUser, clearAuth } from '../services/auth';
import { IconLayers, IconRoof, IconActivity } from './Icons';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = getUser();
  const navBottomRef = useRef(null);

  useEffect(() => {
    if (navBottomRef.current) {
      const activeLink = navBottomRef.current.querySelector('.nav-link.active');
      if (activeLink) {
        activeLink.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  }, [location.pathname]);

  const handleLogout = () => {
    clearAuth();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav className="navbar">
      {/* Top row: logo + title + user */}
      <div className="navbar-top">
        <div className="navbar-top-inner">
          <div className="navbar-brand">
            <img src="/images/logo-green.png" alt="House of Sahyadri" className="navbar-logo-img" />
            <span className="navbar-title">Site Tracker</span>
          </div>
          <div className="navbar-user">
            <div className="user-info">
              <span className="user-name">{user?.name || 'Admin'}</span>
              <span className="user-role">{user?.role || 'Administrator'}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </div>

      {/* Bottom row: nav links */}
      <div className="navbar-bottom">
        <div className="navbar-bottom-inner" ref={navBottomRef}>
          <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
            <IconLayers size={15} /> Dashboard
          </Link>
          <Link to="/projects/skyora" className={`nav-link ${isActive('/projects/skyora') ? 'active' : ''}`}>
            <IconRoof size={15} /> Skyora Karjat <span className="nav-badge">61</span>
          </Link>
          <Link to="/projects/sylvan-villas" className={`nav-link ${isActive('/projects/sylvan-villas') ? 'active' : ''}`}>
            <IconRoof size={15} /> Sahyadri Sylvan Villas <span className="nav-badge">34</span>
          </Link>
          <Link to="/reports" className={`nav-link ${isActive('/reports') ? 'active' : ''}`}>
            <IconActivity size={15} /> Reports &amp; Audits
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
